import React from "react";
import { withRouter } from "react-router-dom";

import { useProgressPercentEffect } from "../Common/hooks/useProgressPercentEffect";
import { useRedirect } from "../Common/hooks/useRedirect";
import { useRegistrationWhyAreYouOnRooForm } from "../Common/registrationState";
import { REGISTRATION_PROGRESS_PERCENT } from "../Common/service";
import { RegistrationPageContainer } from "../RegistrationPageContainer/RegistrationPageContainer";

import { RegistrationWhyAreYouOnRooForm } from "./RegistrationWhyAreYouOnRooForm";
import { FormProvider } from "./RegistrationWhyAreYouOnRooFormContext";
import { useSave, useValidate } from "./service";

const WhyAreYouOnRoo = () => {
  const registrationWhyAreYouOnRooForm = useRegistrationWhyAreYouOnRooForm();
  const { save } = useSave();
  const { validate } = useValidate();
  const { redirectToLicense } = useRedirect();
  useProgressPercentEffect(REGISTRATION_PROGRESS_PERCENT.WhyAreYouOnRoo);

  return (
    <RegistrationPageContainer
      linkProps={{ children: "Back to License", onClick: redirectToLicense }}
    >
      <FormProvider defaultForm={registrationWhyAreYouOnRooForm} save={save} validate={validate}>
        <RegistrationWhyAreYouOnRooForm />
      </FormProvider>
    </RegistrationPageContainer>
  );
};

export const RegistrationWhyAreYouOnRoo = withRouter(WhyAreYouOnRoo);
